/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { formatTimeWithTimeZone } from "../../helpers/dateHelpers";
import types from "../../helpers/types";

const StyledTableCell = styled(TableCell)`
  border-bottom: none !important;
  padding: 2px !important;
`;

function PreviousLegRow({ leg }) {
  let formattedStartTimeActualOrigin;
  let formattedArriveTimeActualOrigin;

  if (leg?.startTimeActualUtc) {
    formattedStartTimeActualOrigin = formatTimeWithTimeZone(
      leg.startTimeActualUtc,
      leg.originFacilityTimeZoneName
    );
  }

  if (leg?.arriveTimeActualUtc) {
    formattedArriveTimeActualOrigin = formatTimeWithTimeZone(
      leg.arriveTimeActualUtc,
      leg.destinationFacilityTimeZoneName
    );
  }

  return (
    <TableRow>
      <StyledTableCell style={{ width: "5%" }}></StyledTableCell>
      <StyledTableCell style={{ width: "6%" }}>
        {leg.legSequence}
      </StyledTableCell>
      <StyledTableCell style={{ width: "12%" }}>
        {types.legStatusesDescriptions[leg.legStatus]}
      </StyledTableCell>
      <StyledTableCell style={{ width: "5%" }}>
        {leg.serviceLevel}
      </StyledTableCell>
      <StyledTableCell style={{ width: "10%" }}>
        {leg.originFacilityAlphaCode}
      </StyledTableCell>
      <StyledTableCell style={{ width: "22%" }}>
        {formattedStartTimeActualOrigin}
      </StyledTableCell>
      <StyledTableCell style={{ width: "10%" }}>
        {leg.destinationFacilityAlphaCode}
      </StyledTableCell>
      <StyledTableCell style={{ width: "22%" }}>
        {formattedArriveTimeActualOrigin}
      </StyledTableCell>
      <StyledTableCell style={{ width: "8%" }}>{leg.miles}</StyledTableCell>
    </TableRow>
  );
}

PreviousLegRow.propTypes = {
  leg: PropTypes.shape({
    arriveTimeActualUtc: PropTypes.string.isRequired,
    destinationFacilityAlphaCode: PropTypes.string.isRequired,
    destinationFacilityTimeZoneName: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    legSequence: PropTypes.number.isRequired,
    legStatus: PropTypes.number.isRequired,
    miles: PropTypes.number.isRequired,
    originFacilityAlphaCode: PropTypes.string.isRequired,
    originFacilityTimeZoneName: PropTypes.string.isRequired,
    serviceLevel: PropTypes.string.isRequired,
    startTimeActualUtc: PropTypes.string.isRequired,
  }).isRequired,
};

export default PreviousLegRow;
